module.exports = __webpack_public_path__ + "static/img/JiuXiang_Banner_winter.5af5bd8a.jpg";